import axios from "axios";

import { deleteCookies, getCookies } from "./constant";

//export const apiURL = "http://localhost:5026/" 
export const apiURL = "https://investor-api.stementis.com/" 

const api = axios.create({
  baseURL: apiURL,
});

api.defaults.headers = {
  Authorization: `Bearer ${getCookies("token")}`,
  "Access-Control-Allow-Origin": `*`,
  "Access-Control-Allow-Methods": "GET,POST,PUT,DELETE,PATCH,OPTIONS",
  "Content-Type": "application/json; charset=utf-8",
  Accept: "*/*",
};

api.interceptors.request.use(
  function (config) {
    config.headers.Authorization = `Bearer ${getCookies("token")}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    if (response?.data?.status === 401) {  
      deleteCookies("token");
      deleteCookies("adminData")
      setTimeout(() => {
        window.location.href = "/login";
      },1500)
      
    }
    return response;
  },
  function (error) {
    if (error?.response?.status === 401) {
      deleteCookies("token");
      deleteCookies("adminData")
      setTimeout(() => {
        window.location.href = "/login";
      },1500)
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default api;
